import { fetchFormDataApi, saveFormDataApi, submitFormDataApi, fetchFormListApi, verifyFormApi, rejectFormApi, getPreSignedUrlApi, adminViewFormApi, sendEmailOtpApi, sendMobileOtpApi, verifyEmailOtpEmergencyApi, verifyMobileOtpEmergencyApi, createCardApi, updateFormDataApi } from "../ENV";
import { fetchApi } from "./FetchAPI";

export async function fetchFormData() {
  var headerValue = {
    Accept: "application/json",
    "Content-type": "application/json",
    "Authorization": `Bearer ${localStorage.getItem('access_token')}`
  };

  const res = await fetchApi(
    fetchFormDataApi,
    "GET",
    "",
    headerValue,
    {}
  );

  // If we have a successful response with form data
  if (res.data?.success === true && res.data?.message !== "No forms found" && res.data?.data) {
    // Store form ID for future use
    localStorage.setItem('form_id', res.data.data._id);
    
    // Return the form data
    return {
      data: {
        ...res.data.data,
          // Normalize new keys for frontend usage
          lost_and_found: typeof res.data.data.lost_and_found === 'boolean' ? res.data.data.lost_and_found : Boolean(res.data.data.lost_n_found),
          terms_and_conditions: Boolean(res.data.data.terms_and_conditions),
        // Handle certificates specially to preserve file info
        medical_condition: {
          ...res.data.data.medical_condition,
          certificate: res.data.data.medical_condition?.certificate || ''
        },
        disability: {
          ...res.data.data.disability,
          certificate: res.data.data.disability?.certificate || '',
          has_certificate: res.data.data.disability?.certificate ? 'yes' : 'no'
        }
      }
    };
  }

  // If no form found or error, return default empty form
  return {
    data: {
      full_name: JSON.parse(localStorage.getItem('user_data'))?.name,
      age: '',
      gender: '',
      weight: '',
      height: '',
      blood_group: '',
      mobile: JSON.parse(localStorage.getItem('user_data'))?.mobile,
      email: JSON.parse(localStorage.getItem('user_data'))?.email,
      medical_condition: {
        name: '',
        notes: '',
        doctor_name: '',
        allergies: '',
        certificate: ''
      },
      symbols: [],
      disability: {
        has_disability: 'no',
        type: '',
        has_certificate: 'no',
        certificate: ''
      },
      emergency_contacts: [
        {
          name: '',
          mobile: '',
          relationship: '',
          email: ''
        }
      ],
      lost_and_found: false,
      address: {
        line_1: '',
        line_2: '',
        city: '',
        state: '',
        pincode: ''
      },
      consent: false
    }
  };
}


export async function saveFormData(formData, medicalCertificate, disabilityCertificate) {
  const formDataToSend = new FormData();
  // Add form data as a string
  delete formData?.medical_condition?.certificate;
  delete formData?.disability?.certificate;
  delete formData?._id;
  delete formData?.user_id;
  delete formData?.created_at;
  delete formData?.status;
  delete formData?.active;
  const formDataStr = JSON.stringify({
    form_id: localStorage.getItem('form_id') || "",
    form_data: formData
  });
  formDataToSend.append('form_data', formDataStr);

  // Only add files if they are actual File objects (newly uploaded)
  if (medicalCertificate instanceof File) {
    formDataToSend.append('medical_certificate', medicalCertificate);
  }
  if (disabilityCertificate instanceof File) {
    formDataToSend.append('disability_certificate', disabilityCertificate);
  }

  const headerValue = {
    Accept: "application/json",
    "Authorization": `Bearer ${localStorage.getItem('access_token')}`
    // Note: Don't set Content-Type, let the browser set it with the boundary
  };

  const res = await fetchApi(
    saveFormDataApi,
    "POST",
    formDataToSend,
    headerValue,
    ""
  );

  // Process the response similar to fetchFormData
  if (res.data?.success === true && res.data?.data) {
    // Store form ID for future use
    localStorage.setItem('form_id', res.data.data._id);
    
    // Return processed form data
    return {
      data: {
        ...res.data.data,
        // Handle certificates specially to preserve file info
        medical_condition: {
          ...res.data.data.medical_condition,
          certificate: res.data.data.medical_condition?.certificate || ''
        },
        disability: {
          ...res.data.data.disability,
          certificate: res.data.data.disability?.certificate || '',
          has_certificate: res.data.data.disability?.certificate ? 'yes' : 'no'
        }
      }
    };
  }
  return res;
}

export async function submitFormData(formData, medicalCertificate, disabilityCertificate) {
  const formDataToSend = new FormData();
  // Add form data as a string
  delete formData?.medical_condition?.certificate;
  delete formData?.disability?.certificate;
  delete formData?._id;
  delete formData?.user_id;
  delete formData?.created_at;
  delete formData?.status;
  delete formData?.active;
  const formDataStr = JSON.stringify({
    form_id: localStorage.getItem('form_id') || "",
    form_data: formData
  });
  formDataToSend.append('form_data', formDataStr);

  // Only add files if they are actual File objects (newly uploaded)
  if (medicalCertificate instanceof File) {
    formDataToSend.append('medical_certificate', medicalCertificate);
  }
  if (disabilityCertificate instanceof File) {
    formDataToSend.append('disability_certificate', disabilityCertificate);
  }

  const headerValue = {
    Accept: "application/json",
    "Authorization": `Bearer ${localStorage.getItem('access_token')}`
    // Note: Don't set Content-Type, let the browser set it with the boundary
  };

  const res = await fetchApi(
    submitFormDataApi,
    "POST",
    formDataToSend,
    headerValue,
    ""
  );

  // Process the response similar to fetchFormData
  if (res.data?.success === true && res.data?.data) {
    // Store form ID for future use
    localStorage.setItem('form_id', res.data.data._id);
    
    // Return processed form data
    return {
      data: {
        ...res.data.data,
        // Handle certificates specially to preserve file info
        medical_condition: {
          ...res.data.data.medical_condition,
          certificate: res.data.data.medical_condition?.certificate || ''
        },
        disability: {
          ...res.data.data.disability,
          certificate: res.data.data.disability?.certificate || '',
          has_certificate: res.data.data.disability?.certificate ? 'yes' : 'no'
        }
      }
    };
  }
  return res;
}

// Admin: update an existing form, using the same payload/response shape as submitFormData
export async function updateFormData(formId, formData, medicalCertificate, disabilityCertificate) {
  const formDataToSend = new FormData();

  // Create a shallow copy so we can safely strip server-managed fields
  const payload = JSON.parse(JSON.stringify(formData || {}));

  if (payload?.medical_condition) {
    delete payload.medical_condition.certificate;
  }
  if (payload?.disability) {
    delete payload.disability.certificate;
  }
  delete payload._id;
  delete payload.user_id;
  delete payload.created_at;
  delete payload.status;
  delete payload.active;

  const formDataStr = JSON.stringify({
    form_id: formId || "",
    form_data: payload
  });

  formDataToSend.append("form_data", formDataStr);

  // Only add files if they are actual File objects (newly uploaded)
  if (medicalCertificate instanceof File) {
    formDataToSend.append("medical_certificate", medicalCertificate);
  }
  if (disabilityCertificate instanceof File) {
    formDataToSend.append("disability_certificate", disabilityCertificate);
  }

  const headerValue = {
    Accept: "application/json",
    "Authorization": `Bearer ${localStorage.getItem("access_token")}`
    // Note: Don't set Content-Type, let the browser set it with the boundary
  };

  const res = await fetchApi(
    updateFormDataApi,
    "POST",
    formDataToSend,
    headerValue,
    ""
  );

  if (res.data?.success === true && res.data?.data) {
    return {
      data: {
        ...res.data.data,
        medical_condition: {
          ...res.data.data.medical_condition,
          certificate: res.data.data.medical_condition?.certificate || ""
        },
        disability: {
          ...res.data.data.disability,
          certificate: res.data.data.disability?.certificate || "",
          has_certificate: res.data.data.disability?.certificate ? "yes" : "no"
        }
      }
    };
  }

  return res;
}

export const fetchForms = async (page = 1, limit = 10, search = '') => {
  try {
    var headerValue = {
      Accept: "application/json",
      "Content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('access_token')}`
    };
    const params = {
      "page": page,
      "limit": limit
    }

    if (search && search.trim() !== '') {
      params.search = search;
    }

    const response = await fetchApi(
      fetchFormListApi,
      "GET",
      {},
      headerValue,
      params
    );

    if (response.status !== 200) {
      throw new Error('Failed to fetch forms');
    }

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const verifyForm = async (formId) => {
  try {
    const headerValue = {
      Accept: "application/json",
      "Content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('access_token')}`
    };

    const response = await fetchApi(
      verifyFormApi,
      "POST",
      JSON.stringify({ form_id: formId }),
      headerValue,
      {}
    );

    if (response.status !== 200) {
      throw new Error('Failed to verify form');
    }

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const rejectForm = async (formId) => {
  try {
    const headerValue = {
      Accept: "application/json",
      "Content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('access_token')}`
    };
    
    const response = await fetchApi(
      rejectFormApi,
      "POST",
      JSON.stringify({ form_id: formId }),
      headerValue,
      {}
    );

    if (response.status !== 200) {
      throw new Error('Failed to reject form');
    }

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getPreSignedUrl = async (filePath) => {
  try {
    const headerValue = {
      Accept: "application/json",
      "Content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('access_token')}`
    };
    
    const response = await fetchApi(
      getPreSignedUrlApi,
      "GET",
      {},
      headerValue,
      { file_path: filePath }
    );

    if (response.status !== 200) {
      throw new Error('Failed to get pre-signed URL');
    }

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const adminViewForm = async (formId) => {
  try {
    const headerValue = {
      Accept: "application/json",
      "Content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('access_token')}`
    };

    const response = await fetchApi(
      adminViewFormApi,
      "GET",
      {},
      headerValue,
      { form_id: formId }
    );

    if (response.status !== 200) {
      throw new Error('Failed to load form');
    }

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const createCard = async (userId, formId) => {
  try {
    const headerValue = {
      Accept: "application/json",
      "Content-type": "application/json",
      "Authorization": `Bearer ${localStorage.getItem('access_token')}`
    };

    const response = await fetchApi(
      createCardApi,
      "POST",
      JSON.stringify({ user_id: userId, form_id: formId }),
      headerValue,
      {}
    );

    if (response.status !== 200) {
      const msg = response?.data?.message || 'Failed to create card';
      throw new Error(msg);
    }

    return response.data;
  } catch (error) {
    throw error;
  }
};

// OTP: Emergency Contacts
export const sendEmailOtp = async (email) => {
  const headerValue = {
    Accept: "application/json",
    "Content-type": "application/json",
    "Authorization": `Bearer ${localStorage.getItem('access_token')}`
  };

  const response = await fetchApi(
    sendEmailOtpApi,
    "POST",
    JSON.stringify({ "email": email }),
    headerValue,
    {}
  );

  return response;
};

export const sendMobileOtp = async (mobile) => {
  const headerValue = {
    Accept: "application/json",
    "Content-type": "application/json",
    "Authorization": `Bearer ${localStorage.getItem('access_token')}`
  };

  const response = await fetchApi(
    sendMobileOtpApi,
    "POST",
    JSON.stringify({ "mobile": mobile }),
    headerValue,
    {}
  );

  return response;
};

export const verifyEmailOtp = async (email, otp) => {
  const headerValue = {
    Accept: "application/json",
    "Content-type": "application/json",
    "Authorization": `Bearer ${localStorage.getItem('access_token')}`
  };

  const response = await fetchApi(
    verifyEmailOtpEmergencyApi,
    "POST",
    JSON.stringify({ email, otp }),
    headerValue,
    {}
  );

  return response;
};

export const verifyMobileOtp = async (mobile, otp) => {
  const headerValue = {
    Accept: "application/json",
    "Content-type": "application/json",
    "Authorization": `Bearer ${localStorage.getItem('access_token')}`
  };

  const response = await fetchApi(
    verifyMobileOtpEmergencyApi,
    "POST",
    JSON.stringify({ mobile, otp }),
    headerValue,
    {}
  );

  return response;
};